<script setup>
import CloseSvg from '@svg/new-close.svg'
import { useNotificationsStore } from '@/Stores/notifications'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import BaseNotification from './BaseNotification.vue'
import { onMounted } from 'vue'

const notificationsStore = useNotificationsStore()

onMounted(() => {
    notificationsStore.getNotifications()
})
</script>

<template>
    <TransitionRoot appear as="template" :show="notificationsStore.panelOpen">
        <Dialog as="div" class="relative z-50" v-on:close="notificationsStore.panelOpen = false">
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-300 ease-out"
                leave-from="opacity-100"
                leave-to="opacity-0">
                <div class="fixed inset-0 backdrop-blur-sm bg-[rgba(0,0,0,0.6)] transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="h-screen overflow-hidden">
                    <TransitionChild
                        as="template"
                        enter="transition duration-300 ease-out h-screen"
                        enter-from="opacity-0 translate-x-6"
                        enter-to="opacity-100"
                        leave="transition duration-300 ease-out"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                    >
                        <DialogPanel>
                            <div class="fixed inset-y-0 right-0 w-full max-w-[420px] bg-[rgba(20,22,57,1)] z-50 p-5 flex flex-col">
                                <div class="flex items-center justify-between border-b border-b-[rgba(112,120,176,.20)] pb-3 shrink">
                                    <div class="flex items-center space-x-4">
                                        <button
                                            v-on:click="notificationsStore.panelOpen = false"
                                            class="size-8 flex items-center justify-center touch-manipulation bg-[rgba(27,32,74,1)] rounded-lg"
                                        >
                                            <CloseSvg class="size-6 text-[rgba(132,156,241,1)] touch-manipulation" />
                                        </button>

                                        <h2 class="text-[rgba(233,232,255,1)] font-semibold">Notifications</h2>
                                    </div>

                                    <button
                                        v-if="notificationsStore.unreadNotificationsCount"
                                        v-on:click="notificationsStore.markAllNotificationsRead()"
                                        class="text-xs text-[rgba(112,120,176,1)] font-medium"
                                    >
                                        Mark all as read
                                    </button>
                                </div>

                                <div class="mt-4 pr-2 flex-1 space-y-2 overflow-y-scroll">
                                    <div
                                        v-if="notificationsStore.unreadNotificationsCount === 0"
                                        class="bg-[rgba(27,32,74,1)] p-4 rounded-lg text-[0.75rem] text-center leading-tight text-[rgba(148,162,209,1)]"
                                    >
                                        No unread notifications. You're all caught up!
                                    </div>
                                    <div
                                        v-for="notification in notificationsStore.notifications"
                                        :key="notification.id"
                                        class="bg-[rgba(27,32,74,1)] p-4 rounded-lg text-[0.75rem] leading-snug text-[rgba(148,162,209,1)]"
                                        :class="{ 'bg-[rgba(27,32,74,0.3)] opacity-50': notification.is_read }"
                                    >
                                        <BaseNotification :notification="notification" />
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
